export enum APPLICANT_PREFIXES {
  APPLICANT_1 = 'applicant1',
  APPLICANT_2 = 'applicant2',
}
